<template>
    <div class="footer-banner">
        <div v-if="expanded" class="footer-banner__overlay"></div>

        <div id="fixed-footer-banner"
             :class="{ 'footer-banner__bar--expanded': expanded }"
             class="footer-banner__bar"
             role="alert">

            <div class="footer-banner__inner">
                ⚠️ <strong>Notice:</strong> This platform will be deprecated on 22nd April 2026
                |
                <a class="footer-banner__inner--toggle"
                   href="#"
                   @click.prevent="toggleExpanded">
                    {{ expanded ? 'Hide information' : 'More information' }}
                </a>
            </div>

            <div :class="{ 'footer-banner__extra--expanded': expanded }"
                 class="footer-banner__extra">
                <div class="footer-banner__content">
                    <p>Dear customers,</p>
                    <p>
                        This platform will be deprecated on <strong>22nd April 2026</strong> — 
                        all organisations now have a designated User Manager within your organisation 
                        to manage access moving forward.
                    </p>

                    <p>Here are just a few of the new and improved features you can enjoy on <strong>iRis 6.0</strong>:</p>
                    <ul class="footer-banner__content--list">
                        <li>
                            <strong>Auto Time-Lapse Creator</strong> with advanced filters to
                            sharpen, deflicker, and smooth image transitions
                        </li>
                        <li>
                            <strong>Gallery Batch Download</strong> — select and download
                            images by date range
                        </li>
                        <li>
                            <strong>Mission Control “Wallboard” View</strong> — ideal for
                            full-screen monitoring in shared workspaces, keeping an eye on
                            your entire camera fleet at once
                        </li>
                        <li>
                            <strong>Map View</strong> — see every camera pin position clearly,
                            from anywhere in the world
                        </li>
                        <li>
                            <strong>Advanced Image Compare & Annotation Tool</strong> —
                            compare images using Blend, Window, or Overlay modes. Add mark-ups
                            with key project notes, then save, download, and share whenever
                            needed.
                        </li>
                    </ul>

                    <p>
                        If we can help further, please get in touch via
                        <a href="mailto:support@time-lapse-systems.com">support@time-lapse-systems.com</a>
                    </p>
                </div>
                <div class="footer-banner__buttons">
                    <a class="button-link"
                       href="https://iris6.time-lapse-systems.co.uk/"
                       target="_blank">
                        Go to iRis 6.0
                    </a>
                    <a class="button-link"
                       href="mailto:support@time-lapse-systems.com"
                       target="_blank">
                        Contact Support
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterBanner',
    data() {
        return {
            expanded: false,
        };
    },
    methods: {
        toggleExpanded() {
            this.expanded = !this.expanded;
        },
    },
};
</script>

<style lang="scss" scoped>
$footer-banner-header-bg: #be132d;
$footer-banner-header-text: #fff;
$footer-banner-header-link: #fff700;
$footer-banner-content-bg: #f8f8f8;
$footer-banner-content-text: #101010;

.footer-banner {
  &__overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 999;
  }

  &__bar {
    position: relative;
    z-index: 1000;
    width: 100%;
    background: $footer-banner-header-bg;
    color: $footer-banner-header-text;
    text-align: center;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.25);
  }

  &__inner {
    padding: 1rem;
    font-size: 1rem;
    text-wrap: balance;

    @media (max-width: 768px) {
      min-height: 80px;
    }

    strong {
      color: $footer-banner-header-link;
    }

    &--toggle {
      color: $footer-banner-header-text;
      font-weight: bold;
      cursor: pointer;
      text-decoration: underline;
    }
  }

  /* Extra content wrapper */
  &__extra {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease, padding 0.3s ease;
    color: $footer-banner-content-text;
    background: $footer-banner-content-bg;
    padding: 0 1rem;
    text-wrap: balance;
  }

  /* Expanded: make this a flex column and cap height */
  &__extra--expanded {
    max-height: 70vh;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @media (min-width: 768px) {
      padding-right: 1rem;
    }
  }

  /* Scrollable content area */
  &__content {
    max-width: 800px;
    margin: 0 auto;
    text-align: left;
    text-wrap: pretty;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-gutter: stable;

    &--list {
      list-style-type: disc;
      margin-left: 1rem;

      li {
        margin-bottom: 0.5rem;
      }
    }

    p {
      margin-bottom: 1rem;
    }
  }

  /* Footer Buttons */
  &__buttons {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 3rem;

    .button-link {
      display: inline-block;
      padding: 0.5rem 1rem;
      background: $footer-banner-content-text;
      color: $footer-banner-content-bg;
      text-decoration: none;
      margin-top: 1rem;
    }
  }
}
</style>
